import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import MorningCallModal from "../../components/modal/MorningCallModal";
import { alarmState, AlarmType } from "../../recoil/alarm";
import { langState } from "../../recoil/lang";
import moment from "moment-timezone";
import { MorningCallAudio } from "../../utils/Audio";

let interval: any;
let morningCallInterval: any;

const MorningCallContent = () => {
  const alarmFlag = useRecoilValue<AlarmType>(alarmState);
  const [visibleMorningCall, setVisibleMorningCall] = useState<boolean>(false);

  const playMorningCallAudio = () => {
    if (MorningCallAudio) {
      morningCallInterval = setTimeout(() => {
        MorningCallAudio.currentTime = 0;
        MorningCallAudio.play();
      }, MorningCallAudio.duration * 1000);
    }
  };

  useEffect(() => {
    if (alarmFlag.is_available && alarmFlag.time && !visibleMorningCall) {
      interval = setInterval(() => {
        if (
          alarmFlag.time &&
          new Date().getHours() === moment(alarmFlag.time).hour() &&
          new Date().getMinutes() === moment(alarmFlag.time).minute()
        ) {
          clearInterval(interval);
          setVisibleMorningCall(true);
        }
      }, 1000);
    }

    if (MorningCallAudio) {
      if (visibleMorningCall) {
        console.log("audio", MorningCallAudio.duration);

        MorningCallAudio.currentTime = 0;
        MorningCallAudio.play();
        MorningCallAudio.addEventListener("ended", playMorningCallAudio);
      } else {
        console.log("pause", MorningCallAudio);
        MorningCallAudio.pause();
        MorningCallAudio.currentTime = 0;
        clearTimeout(morningCallInterval);
      }
    }

    return () => {
      clearInterval(interval);
      MorningCallAudio.pause();
      MorningCallAudio.currentTime = 0;
      MorningCallAudio.removeEventListener("ended", playMorningCallAudio);
    };
  }, [alarmFlag, visibleMorningCall]);

  return (
    <>
      <MorningCallModal
        isVisible={visibleMorningCall}
        setVisible={setVisibleMorningCall}
      />
    </>
  );
};

export default MorningCallContent;
